import React, { Fragment, useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  makeStyles,
  Button,
  CircularProgress,
  Tooltip,
  Box,
  Chip,
  Avatar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  CardActions,
} from "@material-ui/core";
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { DownloadOutlined } from "@ant-design/icons";
import moment from "moment";
import LockIcon from "@material-ui/icons/Lock";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { withStyles } from "@material-ui/core/styles";
import HttpService from "../services/httpService";
import CenterFocusWeakIcon from "@material-ui/icons/CenterFocusWeak";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  tableHeader: {
    backgroundColor: "#1C375D",
    color: "white",
    fontWeight: "bold",
  },
  tableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },

  frozenPage: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    fontSize: "24px",
    flexDirection: "column",
  },
  freezeMessage: {
    marginBottom: theme.spacing(2),
    textAlign: "center",
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(3),
  },
  title1: {
    marginBottom: theme.spacing(2),
    fontWeight: "bold",
    fontSize: "1.2rem",
    textAlign: "center",
  },
  accordionHeading: {
    display: "flex",
    color: "black",
    fontWeight: 600,
    fontSize: "17px",
    // fontWeight: "bold",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    // fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  accordionHeadingText: {
    fontWeight: 600,
    fontSize: "17px",
    color: "black",
  },

  countBadge: {
    backgroundColor: "#1C375D",
    color: "white",
    borderRadius: "50%",
    padding: "2px 8px",
    marginLeft: "8px",
    fontSize: "0.8rem",
  },
  lockedTable: {
    backgroundColor: "#f5f5f5",
  },

  teamChip: {
    margin: theme.spacing(0.5),
  },
  teamContainer: {
    margin: theme.spacing(2, 0),
  },
  filterChip: {
    margin: theme.spacing(0.5),
    backgroundColor: "#e3f2fd",
  },
  completedTable: {
    backgroundColor: "#e8f5e9",
  },
  tableStatus: {
    marginLeft: theme.spacing(1),
    fontSize: "0.8rem",
    fontWeight: "bold",
  },
  statusCompleted: {
    color: "#2e7d32",
  },
  statusPending: {
    color: "#d32f2f",
  },
  statusCritical: {
    color: "#ff0000",
  },
  statusNext: {
    color: "#ff8f00",
  },
  currentTableHeader: {
    backgroundColor: "#e3f2fd",
  },
  errorTable: {
    backgroundColor: "red",
    "& $accordionHeadingText": { 
      color: "white !important",
    },
  },
  dateFilterContainer: {
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  orangeButton: {
    backgroundColor: "#f47E46",
    color: "white",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#e06d36",
    },
  },
  tableFont: {
    fontSize: "17px",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', 
    fontWeight: 800,
  },
  headerFont: {
    fontSize: "15px",
    fontWeight: 600, 
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  accordionTitle: {
    fontWeight: 600, 
    fontSize: "16px",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  // Update your existing cellStyle
  cellStyle: {
    padding: 10,
    width: 500,
    textAlign: "center",
    fontWeight: 600, 
    backgroundColor: "#1C375D",
    color: "white",
    fontSize: "14px",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  dateFilterContainer: {
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    flexWrap: "wrap", 
  },
  datePicker: {
    minWidth: 220,
    marginBottom: theme.spacing(1),
    "& .MuiInputLabel-root": {
      color: theme.palette.text.primary,
      fontWeight: 500,
      marginBottom: 4, 
      transform: "none",
      position: "static", 
      "&.Mui-focused": {
        color: theme.palette.primary.main,
      },
    },
    "& .MuiInputBase-root": {
      marginTop: 0, 
    },
    "& .MuiInputBase-input": {
      padding: "8px 10px", 
    },
  },

  orangeButton: {
    backgroundColor: "#f47E46",
    color: "white",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#e06d36",
    },
  },
  clearButton: {
    marginLeft: theme.spacing(1),
    textTransform: "none",
    fontWeight: 500,
    borderColor: theme.palette.grey[400],
    color: theme.palette.grey[700],
    "&:hover": {
      borderColor: theme.palette.grey[600],
      backgroundColor: "transparent",
    },
  },
  buttonGroup: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
  },
  customTooltip: {
    backgroundColor: "#000 !important",
    color: "#fff !important",
    fontSize: "14px !important",
    padding: "8px 12px !important",
    boxShadow: theme.shadows[4],
  },
  customArrow: {
    color: "#000 !important",
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#1C375D",
    color: "#FFF2EB",
    fontWeight: 600, // Changed from 500 to 600
    textAlign: "center",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: "14px",
  },
  body: {
    fontSize: "14px",
    textAlign: "center",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 500,
  },
}))(TableCell);

const ASMDashboard = () => {
  const { userDetails } = useSelector((state) => state.user);
  const classes = useStyles();
  const [loading, setLoading] = useState({
    table1: true,
    table2: true,
    table3: true,
    table4: true,
    table5: true,
    table6: true,
    table7: true,
    table8: true,
    table9: true,
    table10: true,
  });
  const [dashboardFrozen, setDashboardFrozen] = useState(() => {
    const saved = localStorage.getItem("dashboardFrozen");
    return saved !== null ? JSON.parse(saved) : false;
  });
  const [taskAssignTitleDetail, setTaskAssignTitleDetail] = useState();
  const [freezePage, setFreezePage] = useState(false);
  const [freezeReason, setFreezeReason] = useState("");
  const [expanded, setExpanded] = useState({
    table1: false,
    table2: false,
    table3: false,
    table4: false,
    table5: false,
    table6: false,
    table7: false,
    table8: false,
    table9: false,
    table10: false,
  });
  const [tablesData, setTablesData] = useState({
    table1: {
      data: [],
      shouldFreeze: false,
      freezeThreshold: null,
      teamDetails: null,
      filtersApplied: null,
      completed: false,
    },
    table2: {
      data: [],
      shouldFreeze: false,
      freezeThreshold: null,
      teamDetails: null,
      filtersApplied: null,
      completed: false,
    },
    table3: {
      data: [],
      shouldFreeze: false,
      freezeThreshold: null,
      teamDetails: null,
      filtersApplied: null,
      completed: false,
    },
    table4: {
      data: [],
      shouldFreeze: false,
      freezeThreshold: null,
      teamDetails: null,
      filtersApplied: null,
      completed: false,
    },
    table5: {
      data: [],
      shouldFreeze: false,
      freezeThreshold: null,
      teamDetails: null,
      filtersApplied: null,
      completed: false,
    },
    table6: {
      data: [],
      shouldFreeze: false,
      freezeThreshold: null,
      teamDetails: null,
      filtersApplied: null,
      completed: false,
    },
    table7: {
      data: [],
      shouldFreeze: false,
      freezeThreshold: null,
      teamDetails: null,
      filtersApplied: null,
      completed: false,
    },
    table8: {
      data: [],
      shouldFreeze: false,
      freezeThreshold: null,
      teamDetails: null,
      filtersApplied: null,
      completed: false,
    },
    table9: {
      data: [],
      shouldFreeze: false,
      freezeThreshold: null,
      teamDetails: null,
      filtersApplied: null,
      completed: false,
    },
    table10: {
      data: [],
      shouldFreeze: false,
      freezeThreshold: null,
      teamDetails: null,
      filtersApplied: null,
      completed: false,
    },
  });
  const [currentActiveTable, setCurrentActiveTable] = useState("table1");
  const [determiningActiveTable, setDeterminingActiveTable] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [filterApplied, setFilterApplied] = useState(false);
  const [taskAssignTitleModal, setTaskAssignTitleModal] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [resolveIssueData, setResolveIssueData] = useState({});
  const [viewConfirmationDialog, setViewConfirmationDialog] = useState(false);
  const [leadLogId, setLeadLogId] = useState();
  const [leadId, setLeadId] = useState();
  const [dateRange, setDateRange] = useState({
    startDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  useEffect(() => {
    const keys = ["table1", "table3", "table4", "table7"];
    const anyFreeze = keys.some((key) => tablesData[key]?.shouldFreeze);
    setDashboardFrozen(anyFreeze);
    localStorage.setItem("dashboardFrozen", JSON.stringify(anyFreeze));
  }, [tablesData]);

  const filterDataByDateRange = (data) => {
    if (!filterApplied || !dateRange?.startDate || !dateRange?.endDate || !data)
      return data;

    const start = moment(dateRange.startDate).startOf("day");
    const end = moment(dateRange.endDate).endOf("day");

    return data.filter((item) => {
      const dateValue =
        item?.createdAt ||
        item?.Create_Date ||
        item?.created_date ||
        item?.leadCreatedDate;

      if (!dateValue) return false;

      const itemDate = moment(dateValue);
      return itemDate.isBetween(start, end, null, "[]");
    });
  };

  const apiFunctions = {
    table1: HttpService.getLeadsReceived,
    table2: HttpService.getRNCStageLeads,
    table3: HttpService.getRCStageLeads,
    table4: HttpService.getHotDealChecklist,
    table5: HttpService.getRightPipelineTasks,
    table6: HttpService.getLeftPipelineTasks,
    table7: HttpService.getASMOverdueTasks,
    table8: HttpService.getTeamOverdueTasks,
    table9: HttpService.getASMUpcomingTasks,
    table10: HttpService.getTeamUpcomingTasks,
  };
  const handleTaskAssignTitle = async (data) => {
    // console.log(data)
    try {
      setTaskAssignTitleDetail(data);
      setTaskAssignTitleModal(true);
    } catch (error) {
      // props.setSnackInfo('Something wents wrong','error');
      console.error("error", error);
    }
  };

  useEffect(() => {
    const savedState = localStorage.getItem("asmDashboardState");
    if (savedState) {
      try {
        const {
          currentActiveTable: savedActiveTable,
          completedTables,
          tableLengths: savedTableLengths,
        } = JSON.parse(savedState);

        setCurrentActiveTable(savedActiveTable);

        setTablesData((prev) => {
          const updated = { ...prev };
          Object.keys(updated).forEach((key) => {
            updated[key].completed = completedTables?.includes(key) || false;
          });
          return updated;
        });
      } catch (error) {
        console.error("Error parsing saved state:", error);
      }
    }
  }, []);

  useEffect(() => {
    const completedTables = Object.keys(tablesData).filter(
      (key) => tablesData[key]?.completed
    );

    const tableLengths = {};
    for (let i = 1; i <= 7; i++) {
      const tableKey = `table${i}`;
      tableLengths[tableKey] = tablesData[tableKey]?.data?.length || 0;
    }

    const stateToSave = {
      currentActiveTable,
      completedTables,
      tableLengths,
    };

    localStorage.setItem("asmDashboardState", JSON.stringify(stateToSave));
  }, [currentActiveTable, tablesData]);

  const determineCurrentActiveTable = () => {
    const freezeTriggerTables = [
      "table1",
      // "table2",
      "table3",
      "table4",
      // "table5",
      "table7",
    ];

    const frozenTable = freezeTriggerTables.find(
      (key) => tablesData[key]?.shouldFreeze
    );
    if (frozenTable) return frozenTable;

    for (let i = 1; i <= 10; i++) {
      const tableKey = `table${i}`;
      if (tablesData[tableKey]?.data?.length > 0) {
        return tableKey;
      }
    }

    return "table1";
  };

  useEffect(() => {
    const fetchAllTables = async () => {
      setDeterminingActiveTable(true);
      await Promise.all(Object.keys(apiFunctions).map(fetchTableData));
      setDeterminingActiveTable(false);
    };
    fetchAllTables();
  }, [selectedDate]);

  const refreshAllTables = async () => {
    setDeterminingActiveTable(true);
    await Promise.all(Object.keys(apiFunctions).map(fetchTableData));
    setDeterminingActiveTable(false);
    setRemarks("");
  };

  const fetchTableData = async (tableKey) => {
    try {
      const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
      const response = await apiFunctions[tableKey]?.(
        userDetails?._id,
        formattedDate
      );

      if (response?.data?.success) {
        const shouldFreeze = [
          "table1",
          // "table2",
          "table3",
          "table4",
          // "table5",
          "table6",
          "table7",
        ].includes(tableKey)
          ? response?.data?.shouldFreeze || false
          : false;

        setTablesData((prev) => ({
          ...prev,
          [tableKey]: {
            ...prev[tableKey],
            data: response?.data?.data || [],
            shouldFreeze,
            freezeThreshold: response?.freezeThreshold || null,
            teamDetails: response?.teamDetails || null,
            filtersApplied: response?.filtersApplied || null,
            completed: prev[tableKey]?.completed || false,
          },
        }));

        if (shouldFreeze) {
          setFreezePage(true);
          setFreezeReason(
            response?.freezeThreshold?.reason ||
              "Critical issues need attention"
          );
        }
      }
    } catch (error) {
      console.error(`Error fetching ${tableKey} data:`, error);
      setTablesData((prev) => ({
        ...prev,
        [tableKey]: {
          ...prev[tableKey],
          data: [],
          shouldFreeze: false,
        },
      }));
    } finally {
      setLoading((prev) => ({
        ...prev,
        [tableKey]: false,
      }));
    }
  };

 
  const isTableDisabled = (tableKey) => {
    // Tables that should always be active (1,2,3,4,5,7)
    const alwaysActiveTables = [
      "table1",
      // "table2",
      "table3",
      "table4",
      // "table5",
      "table7",
    ];
    if (alwaysActiveTables.includes(tableKey)) {
      return false; // These tables are never disabled
    }

    // For tables 6,8,9,10 - check if any freeze condition exists
    const freezeTriggerTables = [
      "table1",
      // "table2",
      "table3",
      "table4",
      // "table5",
      "table6",
      "table7",
    ];
    const criticalTableFrozen = freezeTriggerTables.some(
      (key) => tablesData[key]?.shouldFreeze === true
    );

    // Only disable if there's a freeze condition and this table isn't the frozen one
    if (criticalTableFrozen && !tablesData[tableKey]?.shouldFreeze) {
      return true;
    }

    return false;
  };
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded({ ...expanded, [panel]: isExpanded });
  };

  const handleUnfreeze = () => {
    setTablesData((prev) => ({
      ...prev,
      [currentActiveTable]: {
        ...prev[currentActiveTable],
        completed: true,
        shouldFreeze: false,
      },
    }));

    const newActiveTable = determineCurrentActiveTable();
    setCurrentActiveTable(newActiveTable);

    setFreezePage(false);
    setFreezeReason("");
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDateRange((prev) => {
      const newRange = {
        ...prev,
        [name]: value,
      };

      if (
        newRange.startDate &&
        newRange.endDate &&
        moment(newRange.endDate).isBefore(newRange.startDate)
      ) {
        console.error("End date cannot be before start date");
        return prev;
      }

      return newRange;
    });
  };

  const getTableStatus = (tableKey) => {
    const alwaysActiveTables = [
      "table1",
      // "table2",
      "table3",
      "table4",
      // "table5",
      "table7",
    ];

    // Don't show status for always-active tables
    if (alwaysActiveTables.includes(tableKey)) {
      return null;
    }
    if (tablesData[tableKey]?.shouldFreeze) {
      return (
        <span
          className={`${classes.tableStatus} ${classes.statusCritical}`}
        ></span>
      );
    }

    if (
      ["table6", "table8", "table9", "table10"].includes(tableKey) &&
      tablesData[tableKey]?.data?.length > 0
    ) {
      return null;
    }

    const freezeTriggerTables = [
      "table1",
      // "table2",
      "table3",
      "table4",
      // "table5",
      "table7",
    ];
    const anyTableFrozen = freezeTriggerTables.some(
      (key) => tablesData[key]?.shouldFreeze === true
    );

    if (!anyTableFrozen) {
      if (tablesData[tableKey]?.data?.length === 0) {
        return (
          <span
            className={`${classes.tableStatus} ${classes.statusCompleted}`}
          ></span>
        );
      }
      return null;
    }

    return (
      <span className={`${classes.tableStatus} ${classes.statusPending}`}>
        {/* (Locked) */}
      </span>
    );
  };


  const getExpandIcon = (tableKey) => {
    const alwaysActiveTables = [
      "table1",
      // "table2",
      "table3",
      "table4",
      // "table5",
      "table7",
    ];

    // Always show dropdown for always-active tables
    if (alwaysActiveTables.includes(tableKey)) {
      return <ArrowDropDownIcon />;
    }

    // Rest of your existing logic for other tables
    if (tablesData[tableKey]?.shouldFreeze) {
      return <ArrowDropDownIcon />;
    }

    const anyTableFrozen = [
      "table1",
      // "table2",
      "table3",
      "table4",
      // "table5",
      "table6",
      "table7",
    ].some((key) => tablesData[key]?.shouldFreeze);

    if (!anyTableFrozen) {
      return <ArrowDropDownIcon />;
    }

    return <LockIcon />;
  };

  const getAccordionClass = (tableKey) => {
    if (tablesData[tableKey]?.shouldFreeze) {
      return classes.errorTable;
    }
    if (tablesData[tableKey]?.completed) {
      return classes.completedTable;
    }

    if (
      ["table8", "table9", "table10"].includes(tableKey) &&
      tablesData[tableKey]?.data?.length > 0
    ) {
      return "";
    }

    if (isTableDisabled(tableKey)) {
      return classes.lockedTable;
    }
    return "";
  };

  const renderTeamDetails = (teamDetails) => {
    if (!teamDetails) return null;

    return (
      <div className={classes.teamContainer}>
        <Typography variant="subtitle1">
          Team Members ({teamDetails?.memberCount || 0}):
        </Typography>
        <Box>
          {teamDetails?.members?.map((member, index) => (
            <Chip
              key={index}
              avatar={<Avatar>{member?.name?.charAt(0)}</Avatar>}
              label={`${member?.name || ""}${
                member?.isAssistantManager ? " (ASM)" : ""
              }`}
              className={classes.teamChip}
              color={member?.isAssistantManager ? "primary" : "default"}
            />
          ))}
        </Box>
      </div>
    );
  };

  const renderFilters = (filters) => {
    if (!filters) return null;

    return (
      <div>
        <Typography variant="subtitle1">Filters Applied:</Typography>
        <Box>
          {Object.entries(filters).map(([key, value], index) => (
            <Chip
              key={index}
              label={`${key}: ${value}`}
              className={classes.filterChip}
            />
          ))}
        </Box>
      </div>
    );
  };

  const resolveIssue = (data) => {
    setViewConfirmationDialog(true);
    setResolveIssueData(data);
  };
  const handleCancel = () => {
    setViewConfirmationDialog(false);
    setRemarks("");
  };
  const handleResolveConfirm = async () => {
    try {
      let obj = {
        remarks: remarks,
        createTicketFromNotes: true,
        leadId: resolveIssueData._id,
        uniqueTicketNo: resolveIssueData.Ticket_No,
      };
      // console.log(resolveIssueData)
      const response = await HttpService.resolveTaskticket(
        resolveIssueData._id,
        obj
      );
      if (response.status === 200) {
        // props.setSnackInfo("Internal Ticket Resolved Succesfully", "Success");
        setViewConfirmationDialog(false);
        refreshAllTables();
        // taskAssigned();
        // taskAssignedNotDue();
      }
    } catch (err) {
      console.error(err);
      // props.setSnackInfo('Something wents wrong','error');
    }
  };
  const [reminderDueTitleDetail, setReminderDueTitleDetail] = useState();
  const [reminderDueTitleModal, setReminderDueTitleModal] = useState(false);
  const [reminderCloseDialog, setReminderCloseDialog] = useState(false);
  const [reminderCloseRemark, setReminderCloseRemark] = useState("");
  // Reminer Due handle Title
  const handleReminderDueTitle = async (item) => {
    try {
      // const res = await HttpService.getReminderDueTitleDetail(item.leadId);
      setReminderDueTitleDetail(item);
      setReminderDueTitleModal(true);
    } catch (error) {
      console.error("error", error);
    }
  };
  //  handle reminder close submit button
  const handleReminderCloseButton = async () => {
    try {
      let obj = {
        leadId: leadId,
        leadLogId: leadLogId,
        reminderCloseRemark: reminderCloseRemark,
      };
      let res = await HttpService.closeReminder(leadLogId, obj);

      setReminderCloseDialog(false);
      setReminderDueTitleModal(false);

      setReminderCloseRemark("");
      refreshAllTables();

    } catch (err) {
      // props.setSnackInfo("Something went wrong", 'error');
      console.error(err);
    }
    // props.setLoading(false);
  };

  const handleClose = (data) => {
    setLeadId(data?.leadId);
    setReminderCloseDialog(true);
    setLeadLogId(data?.leadLogId);
  };
  const tableNames = {
    table1: "Leads Received",
    // table2: "Leads in Requirement not collected stage",
    table3: "Leads in Requirement collected stage",
    table4: "Leads where the hot deal checklist is not filled",
    // table5: "Leads where task is not assigned (Right pipeline)",
    table7: "Task assigned",
  };

  const isLoading =
    Object.values(loading).some((val) => val === true) ||
    determiningActiveTable;

  if (isLoading) {
    return (
      <div className={classes.loading}>
        <CircularProgress />
        <Typography>Loading dashboard data...</Typography>
      </div>
    );
  }

  return (
    <>  
      <div className={classes.header}>
        <Typography variant="h4" className={classes.title1}>
          ASM Dashboard
        </Typography>
      </div>
    <Paper className={classes.paper}>
      <div className={classes.root}>
        <Box className={classes.dateFilterContainer}>

          <Button
            variant="contained"
            className={classes.orangeButton}
            onClick={refreshAllTables}
            disabled={determiningActiveTable}
          >
            Refresh All Tables
          </Button>
        </Box>

        {Object.entries(tablesData).some(([_, val]) => val.shouldFreeze) && (
          <h3
            style={{
              marginTop: "5px",
              color: "black",
              textAlign: "left",
              marginBottom: "3px",
            }}
          >
            Note: Please address the overdue tasks in the following table(s) to
            proceed:{" "}
            {Object.entries(tablesData)
              .filter(([_, val]) => val.shouldFreeze)
              .map(([key], index, arr) => (
                <span key={key} style={{ color: "red" }}>
                  • {tableNames[key] || key}
                  {index < arr.length - 1 ? ", " : ""}
                </span>
              ))}{" "}
            . Once cleared, you will gain access to other tasks and tables.
          </h3>
        )}
        {/* Resolve Dialog */}

        <Fragment>
          <Dialog
            open={viewConfirmationDialog}
            keepMounted
            onClose={() => setViewConfirmationDialog(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <Card>
              <CardActionArea className={classes.cardDialog}>
                <CardContent className={classes.cardDialog}>
                  <span
                    style={{
                      fontWeight: "600",
                      textAlign: "center",
                      fontSize: "15px",
                      marginRight: "10px",
                    }}
                  >
                    Internal Ticket Id:
                  </span>
                  <span style={{ fontSize: "15px" }}>
                    {resolveIssueData?.Ticket_No}
                  </span>{" "}
                  <br />
                  <br />
                  <span
                    style={{
                      fontWeight: "600",
                      textAlign: "center",
                      fontSize: "15px",
                      marginRight: "10px",
                    }}
                  >
                    Title:
                  </span>
                  <span style={{ fontSize: "15px" }}>
                    {resolveIssueData?.Task_Title}
                  </span>{" "}
                  <br />
                  <br />
                  <span
                    style={{
                      fontWeight: "600",
                      textAlign: "center",
                      fontSize: "15px",
                      marginRight: "10px",
                    }}
                  >
                    Attachement:
                  </span>
                  <span style={{ fontSize: "15px" }}>
                    {resolveIssueData &&
                    resolveIssueData.attachedFiles &&
                    resolveIssueData.attachedFiles.length > 0 &&
                    resolveIssueData.attachedFiles[0].trim() !== "" ? (
                      <DownloadOutlined
                        onClick={() =>
                          window.open(resolveIssueData.attachedFiles[0])
                        }
                        style={{
                          color: "green",
                          cursor: "pointer",
                          fontWeight: "bold",
                          fontSize: "24px",
                        }}
                      />
                    ) : (
                      "No Attachment"
                    )}
                  </span>{" "}
                  <br />
                  <br />
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    Click confirm to Resolve this Internal Ticket
                  </Typography>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <TextField
                  id="remarks"
                  name="remarks"
                  label="Remarks"
                  type="text"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  className={classes.textField}
                />
              </CardActions>
              <CardActions style={{ justifyContent: "right" }}>
                <Button
                  onClick={handleCancel}
                  style={{ backgroundColor: "#F50057", color: "#fff" }}
                  variant="contained"
                >
                  Cancel
                </Button>
                <Button
                  style={{ backgroundColor: "#F47E46", color: "#fff" }}
                  onClick={handleResolveConfirm}
                  variant="contained"
                >
                  Confirm
                </Button>
              </CardActions>
            </Card>
          </Dialog>
        </Fragment>
        {/* Task assign by manager Title Modal */}
        <Dialog
          open={taskAssignTitleModal}
          onClose={() => setTaskAssignTitleModal(false)}
        >
          <DialogTitle>Task assign by manager Title Modal </DialogTitle>
          <DialogContent>
            <p>
              <strong>Title: </strong> {taskAssignTitleDetail?.Task_Title}{" "}
            </p>
            <p>
              <strong>Description: </strong>{" "}
              {taskAssignTitleDetail?.ticketDescription}{" "}
            </p>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setTaskAssignTitleModal(false);
              }}
              style={{ backgroundColor: "#F50057", color: "#fff" }}
              variant="contained"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        {/* Reminder Due Title Modal */}
        <Dialog
          open={reminderDueTitleModal}
          onClose={() => setReminderDueTitleModal(false)}
        >
          <DialogTitle>Reminder Due Details</DialogTitle>
          <DialogContent>
            <Card>
              <CardActionArea className={classes.cardDialog}>
                <CardContent className={classes.cardDialog}>
                  <span
                    style={{
                      fontWeight: "600",
                      textAlign: "center",
                      fontSize: "15px",
                      marginRight: "10px",
                    }}
                  >
                    Notes -{" "}
                  </span>
                  <span style={{ fontSize: "15px" }}>
                    {reminderDueTitleDetail?.Notes}
                  </span>{" "}
                  <br />
                  <br />
                  <span
                    style={{
                      fontWeight: "600",
                      textAlign: "center",
                      fontSize: "15px",
                      marginRight: "10px",
                    }}
                  >
                    Reminder Date -{" "}
                  </span>
                  <span style={{ fontSize: "15px" }}>
                    {reminderDueTitleDetail?.Expected_Closure_Date
                      ? moment(
                          reminderDueTitleDetail?.Expected_Closure_Date
                        ).format("DD-MM-YYYY")
                      : "-"}
                  </span>{" "}
                  <br />
                  <br />
                  <span
                    style={{
                      fontWeight: "600",
                      textAlign: "center",
                      fontSize: "15px",
                      marginRight: "10px",
                    }}
                  >
                    Attachement -{" "}
                  </span>
                  <span style={{ fontSize: "15px" }}>
                    {reminderDueTitleDetail &&
                    reminderDueTitleDetail?.attachedFiles &&
                    reminderDueTitleDetail?.attachedFiles.length > 0 ? (
                      <DownloadOutlined
                        onClick={() =>
                          window.open(reminderDueTitleDetail?.attachedFiles[0])
                        }
                        style={{
                          color: "green",
                          cursor: "pointer",
                          fontWeight: "bold",
                          fontSize: "24px",
                        }}
                      />
                    ) : (
                      "No Attachment"
                    )}
                  </span>
                </CardContent>
              </CardActionArea>
            </Card>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setReminderDueTitleModal(false);
              }}
              style={{ backgroundColor: "#F50057", color: "#fff" }}
              variant="contained"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                handleClose(reminderDueTitleDetail);
              }}
              style={{ backgroundColor: "#F47E46", color: "#fff" }}
              variant="contained"
            >
              Close Reminder
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={reminderCloseDialog}
          onClose={() => setReminderCloseDialog(false)}
        >
          <DialogTitle>Enter Close Reminder Remarks</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="remarks"
              label="Remarks"
              type="text"
              fullWidth
              style={{ width: 400 }}
              value={reminderCloseRemark}
              onChange={(e) => setReminderCloseRemark(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setReminderCloseDialog(false)}
              color="primary"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={handleReminderCloseButton}
              color="secondary"
              variant="outlined"
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        {/* Table 1: Leads Received */}
        <Accordion
          expanded={expanded.table1}
          onChange={handleAccordionChange("table1")}
          className={`${classes.accordionMargin} ${getAccordionClass(
            "table1"
          )}`}
        >
          <Tooltip
            title={
              isTableDisabled("table1")
                ? "This section is disabled because other tasks are pending."
                : ""
            }
            arrow
            placement="top"
            classes={{
              tooltip: classes.customTooltip,
              arrow: classes.customArrow,
            }}
          >
            <div>
              <AccordionSummary
                disabled={isTableDisabled("table1")}
                expandIcon={
                  isTableDisabled("table1") ? (
                    <LockIcon />
                  ) : (
                    getExpandIcon("table1")
                  )
                }
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className={classes.accordionHeading}>
                  <Typography className={classes.accordionHeadingText}>
                    Leads Received
                    {getTableStatus("table1")}
                  </Typography>
                  <span className={classes.countBadge}>
                    {filterApplied
                      ? filterDataByDateRange(tablesData?.table1?.data)?.length
                      : tablesData?.table1?.data?.length}
                  </span>
                </div>
              </AccordionSummary>
            </div>
          </Tooltip>
          <AccordionDetails style={{ flexDirection: "column", padding: 0 }}>
            {renderTeamDetails(tablesData?.table1?.teamDetails)}
            {renderFilters(tablesData?.table1?.filtersApplied)}
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Sno.</StyledTableCell>
                    <StyledTableCell>Lead no.</StyledTableCell>
                    <StyledTableCell>Customer name</StyledTableCell>
                    <StyledTableCell>Sales Executive</StyledTableCell>
                    <StyledTableCell>ASM</StyledTableCell>
                    <StyledTableCell>Lead created date</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filterDataByDateRange(tablesData.table1.data)?.map(
                    (lead, index) => (
                      <TableRow key={index} className={classes.tableRow}>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell style={{ textAlign: "center", textDecoration: "underline" }}>
                          <Link
                            to={`/project-logs/${lead?._id}`}
                            target="_blank"
                          >
                            {lead?.lead_no || "NA"}
                          </Link>
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.customerId?.name || "NA"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.assignTo?.name || "NA"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.salesAssistantManager?.name || "NA"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.createdAt
                            ? moment(lead.createdAt).format("DD-MM-YYYY")
                            : "-"}
                        </TableCell>
                      </TableRow>
                    )
                  )}
                  {filterDataByDateRange(tablesData?.table1?.data)?.length ===
                    0 && (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        {filterApplied
                          ? "No leads found for selected date range"
                          : "No leads found"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        {/* Table 2: Leads in Requirement not collected stage */}
        <Accordion
          expanded={expanded.table2}
          onChange={handleAccordionChange("table2")}
          className={`${classes.accordionMargin} ${getAccordionClass(
            "table2"
          )}`}
        >
          <Tooltip
            title={
              isTableDisabled("table2")
                ? "This section is disabled because other tasks are pending."
                : ""
            }
            arrow
            placement="top"
            classes={{
              tooltip: classes.customTooltip,
              arrow: classes.customArrow,
            }}
          >
            <div>
              <AccordionSummary
                disabled={isTableDisabled("table2")}
                expandIcon={
                  isTableDisabled("table2") ? (
                    <LockIcon />
                  ) : (
                    getExpandIcon("table2")
                  )
                }
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <div className={classes.accordionHeading}>
                  <Typography className={classes.accordionHeadingText}>
                    Leads in Requirement not collected stage
                    {getTableStatus("table2")}
                  </Typography>
                  <span className={classes.countBadge}>
                    {filterApplied
                      ? filterDataByDateRange(tablesData?.table2?.data)?.length
                      : tablesData?.table2?.data?.length}
                  </span>
                </div>
              </AccordionSummary>
            </div>
          </Tooltip>
          <AccordionDetails style={{ flexDirection: "column", padding: 0 }}>
            {renderTeamDetails(tablesData?.table2?.teamDetails)}
            {renderFilters(tablesData?.table2?.filtersApplied)}
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Sno.</StyledTableCell>
                    <StyledTableCell>Lead no.</StyledTableCell>
                    <StyledTableCell>Customer name</StyledTableCell>
                    <StyledTableCell>Sales Executive</StyledTableCell>
                    <StyledTableCell>ASM</StyledTableCell>
                    <StyledTableCell>Lead created date</StyledTableCell>
                    <StyledTableCell>
                      Days from lead created date
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filterDataByDateRange(tablesData.table2.data)?.map(
                    (lead, index) => {
                      const leadDate = moment(lead?.createdAt);
                      const daysDiff = moment().diff(leadDate, "days");

                      return (
                        <TableRow key={index} className={classes.tableRow}>
                          <TableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ textAlign: "center", textDecoration: "underline" }}
                          >
                            <Link
                              to={`/project-logs/${lead?._id}`}
                              target="_blank"
                            >
                              {lead?.lead_no || "NA"}
                            </Link>
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {lead?.customerId?.name || "NA"}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {lead?.assignTo?.name || "NA"}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {lead?.salesAssistantManager?.name || "NA"}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {lead?.createdAt
                              ? leadDate.format("DD-MM-YYYY")
                              : "-"}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {lead?.daysSinceCreation}
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
                  {filterDataByDateRange(tablesData?.table2?.data)?.length ===
                    0 && (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        {filterApplied
                          ? "No leads found for selected date range"
                          : "No leads found"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        {/* Table 3: Leads in Requirement collected stage */}
        <Accordion
          expanded={expanded.table3}
          onChange={handleAccordionChange("table3")}
          className={`${classes.accordionMargin} ${getAccordionClass(
            "table3"
          )}`}
        >
          <Tooltip
            title={
              isTableDisabled("table3")
                ? "This section is disabled because other tasks are pending."
                : ""
            }
            arrow
            placement="top"
            classes={{
              tooltip: classes.customTooltip,
              arrow: classes.customArrow,
            }}
          >
            <div>
              <AccordionSummary
                disabled={isTableDisabled("table3")}
                expandIcon={
                  isTableDisabled("table3") ? (
                    <LockIcon />
                  ) : (
                    getExpandIcon("table3")
                  )
                }
                aria-controls="panel3a-content"
                id="panel3a-header"
              >
                <div className={classes.accordionHeading}>
                  <Typography className={classes.accordionHeadingText}>
                    Leads in Requirement collected stage
                    {getTableStatus("table3")}
                  </Typography>
                  <span className={classes.countBadge}>
                    {filterApplied
                      ? filterDataByDateRange(tablesData?.table3?.data)?.length
                      : tablesData?.table3?.data?.length}
                  </span>
                </div>
              </AccordionSummary>
            </div>
          </Tooltip>
          <AccordionDetails style={{ flexDirection: "column", padding: 0 }}>
            {renderTeamDetails(tablesData?.table3?.teamDetails)}
            {renderFilters(tablesData?.table3?.filtersApplied)}
            {tablesData?.table3?.freezeThreshold && (
              <Box p={2} bgcolor="#fff8e1">
                <Typography variant="subtitle1" color="error">
                  Freeze Threshold:{" "}
                  {tablesData?.table3?.freezeThreshold?.reason}
                </Typography>
                <Typography>
                  Days: {tablesData.table3?.freezeThreshold?.days} | Cutoff
                  Date:{" "}
                  {moment(
                    tablesData?.table3?.freezeThreshold?.cutoffDate
                  ).format("DD-MM-YYYY")}
                </Typography>
              </Box>
            )}
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Sno.</StyledTableCell>
                    <StyledTableCell>Lead no.</StyledTableCell>
                    <StyledTableCell>Customer name</StyledTableCell>
                    <StyledTableCell>Sales Executive</StyledTableCell>
                    <StyledTableCell>ASM</StyledTableCell>
                    <StyledTableCell>Lead created date</StyledTableCell>
                    <StyledTableCell>Days from Stage movement</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filterDataByDateRange(tablesData?.table3?.data)?.map(
                    (lead, index) => {
                      const movementDate = moment(lead?.stageMovementDate);
                      const daysDiff = lead?.daysFromStageMovement;

                      return (
                        <TableRow key={index} className={classes.tableRow}>
                          <TableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell style={{ textAlign: "center", textDecoration: "underline" }}>
                            <Link
                              to={`/project-logs/${lead?._id}`}
                              target="_blank"
                            >
                              {lead?.lead_no || "NA"}
                            </Link>
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {lead?.customerId?.name || "NA"}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {lead?.assignTo?.name || "NA"}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {lead?.salesAssistantManager?.name || "NA"}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {lead?.createdAt
                              ? moment(lead.createdAt).format("DD-MM-YYYY")
                              : "NA"}
                          </TableCell>
                          <TableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {lead?.stageMovementDate ? daysDiff : "NA"}
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
                  {filterDataByDateRange(tablesData?.table3?.data)?.length ===
                    0 && (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        {filterApplied
                          ? "No leads found for selected date range"
                          : "No leads found"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        {/* Table 4: Hot Deal Checklist */}
        <Accordion
          expanded={expanded.table4}
          onChange={handleAccordionChange("table4")}
          className={`${classes.accordionMargin} ${getAccordionClass(
            "table4"
          )}`}
        >
          <Tooltip
            title={
              isTableDisabled("table4")
                ? "This section is disabled because other tasks are pending."
                : ""
            }
            arrow
            placement="top"
            classes={{
              tooltip: classes.customTooltip,
              arrow: classes.customArrow,
            }}
          >
            <div>
              <AccordionSummary
                disabled={isTableDisabled("table4")}
                expandIcon={
                  isTableDisabled("table4") ? (
                    <LockIcon />
                  ) : (
                    getExpandIcon("table4")
                  )
                }
                aria-controls="panel4a-content"
                id="panel4a-header"
              >
                <div className={classes.accordionHeading}>
                  <Typography className={classes.accordionHeadingText}>
                    Leads where the hot deal checklist is not filled
                    {getTableStatus("table4")}
                  </Typography>
                  <span className={classes.countBadge}>
                    {filterApplied
                      ? filterDataByDateRange(tablesData?.table4?.data)?.length
                      : tablesData?.table4.data?.length}
                  </span>
                </div>
              </AccordionSummary>
            </div>
          </Tooltip>
          <AccordionDetails style={{ flexDirection: "column", padding: 0 }}>
            {renderTeamDetails(tablesData?.table4?.teamDetails)}
            {renderFilters(tablesData?.table4?.filtersApplied)}
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Sno.</StyledTableCell>
                    <StyledTableCell>Lead no.</StyledTableCell>
                    <StyledTableCell>Customer name</StyledTableCell>
                    <StyledTableCell>Sales Executive</StyledTableCell>
                    <StyledTableCell>ASM</StyledTableCell>
                    <StyledTableCell>Lead created date</StyledTableCell>
                    <StyledTableCell>
                      Quotation sent movement date
                    </StyledTableCell>
                    <StyledTableCell>Current stage</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filterDataByDateRange(tablesData?.table4?.data)?.map(
                    (lead, index) => (
                      <TableRow key={index} className={classes.tableRow}>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {" "}
                          {index + 1}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center", textDecoration: "underline" }}
                        >
                          <Link
                            to={`/project-logs/${lead?._id}`}
                            target="_blank"
                          >
                            {lead?.lead_no || "NA"}
                          </Link>
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.customerId?.name || "NA"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.assignToName || "NA"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.asmInfo?.name || "NA"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.createdAt
                            ? moment(lead?.createdAt).format("DD-MM-YYYY")
                            : "NA"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.moveDateQtSent
                            ? moment(lead?.moveDateQtSent).format("DD-MM-YYYY")
                            : "NA"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.currentStage || "NA"}
                        </TableCell>
                      </TableRow>
                    )
                  )}
                  {filterDataByDateRange(tablesData?.table4?.data)?.length ===
                    0 && (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        {filterApplied
                          ? "No leads found for selected date range"
                          : "No leads found"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        {/* Table 5: Right Pipeline Tasks */}
        <Accordion
          expanded={expanded.table5}
          onChange={handleAccordionChange("table5")}
          className={`${classes.accordionMargin} ${getAccordionClass(
            "table5"
          )}`}
        >
          <Tooltip
            title={
              isTableDisabled("table5")
                ? "This section is disabled because other tasks are pending."
                : ""
            }
            arrow
            placement="top"
            classes={{
              tooltip: classes.customTooltip,
              arrow: classes.customArrow,
            }}
          >
            <div>
              <AccordionSummary
                disabled={isTableDisabled("table5")}
                expandIcon={
                  isTableDisabled("table5") ? (
                    <LockIcon />
                  ) : (
                    getExpandIcon("table5")
                  )
                }
                aria-controls="panel5a-content"
                id="panel5a-header"
              >
                <div className={classes.accordionHeading}>
                  <Typography className={classes.accordionHeadingText}>
                    Leads where task is not assigned-Right Pipeline
                    {getTableStatus("table5")}
                  </Typography>
                  <span className={classes.countBadge}>
                    {filterApplied
                      ? filterDataByDateRange(tablesData.table5.data)?.length
                      : tablesData.table5.data?.length}
                  </span>
                </div>
              </AccordionSummary>
            </div>
          </Tooltip>
          <AccordionDetails style={{ flexDirection: "column", padding: 0 }}>
            {renderTeamDetails(tablesData?.table5?.teamDetails)}
            {renderFilters(tablesData?.table5?.filtersApplied)}
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Sno.</StyledTableCell>
                    <StyledTableCell>Lead no.</StyledTableCell>
                    <StyledTableCell>Customer name</StyledTableCell>
                    <StyledTableCell>Sales Executive</StyledTableCell>
                    <StyledTableCell>ASM</StyledTableCell>
                    <StyledTableCell>Lead created date</StyledTableCell>
                    <StyledTableCell>Current stage</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filterDataByDateRange(tablesData?.table5?.data)?.map(
                    (lead, index) => (
                      <TableRow key={index} className={classes.tableRow}>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell style={{ textAlign: "center", textDecoration: "underline" }}>
                          <Link
                            to={`/project-logs/${lead?._id}`}
                            target="_blank"
                          >
                            {lead?.lead_no || "NA"}
                          </Link>
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.customerId?.name || "NA"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.assignTo?.name || "NA"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.salesAssistantManager?.name || "NA"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.createdAt
                            ? moment(lead?.createdAt).format("DD-MM-YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.currentStage || "NA"}
                        </TableCell>
                      </TableRow>
                    )
                  )}
                  {filterDataByDateRange(tablesData?.table5?.data)?.length ===
                    0 && (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        {filterApplied
                          ? "No leads found for selected date range"
                          : "No leads found"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        {/* Table 7: Task assigned to ASM (due yesterday) */}
        <Accordion
          expanded={expanded.table7}
          onChange={handleAccordionChange("table7")}
          className={`${classes.accordionMargin} ${getAccordionClass(
            "table7"
          )}`}
        >
          <Tooltip
            title={
              isTableDisabled("table7")
                ? "This section is disabled because other tasks are pending."
                : ""
            }
            arrow
            placement="top"
            classes={{
              tooltip: classes.customTooltip,
              arrow: classes.customArrow,
            }}
          >
            <div>
              <AccordionSummary
                disabled={isTableDisabled("table7")}
                expandIcon={
                  isTableDisabled("table7") ? (
                    <LockIcon />
                  ) : (
                    getExpandIcon("table7")
                  )
                }
                aria-controls="panel7a-content"
                id="panel7a-header"
              >
                <div className={classes.accordionHeading}>
                  <Typography className={classes.accordionHeadingText}>
                    Task assigned to ASM (Overdue Task)
                    {getTableStatus("table7")}
                  </Typography>
                  <span className={classes.countBadge}>
                    {filterApplied
                      ? filterDataByDateRange(tablesData?.table7?.data).length
                      : tablesData?.table7?.data?.length}
                  </span>
                </div>
              </AccordionSummary>
            </div>
          </Tooltip>
          <AccordionDetails style={{ flexDirection: "column", padding: 0 }}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Sl No.</StyledTableCell>
                    <StyledTableCell>Lead no.</StyledTableCell>
                    <StyledTableCell>Customer Name</StyledTableCell>
                    <StyledTableCell>Sales Executive</StyledTableCell>
                    <StyledTableCell>ASM</StyledTableCell>
                    <StyledTableCell>Assigned BY</StyledTableCell>
                    <StyledTableCell>Task Due Date</StyledTableCell>
                    <StyledTableCell>Create Date</StyledTableCell>
                    <StyledTableCell>Current Date</StyledTableCell>
                    <StyledTableCell>Days Overdue</StyledTableCell>
                    <StyledTableCell colSpan={2}> Task Details</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filterDataByDateRange(tablesData?.table7?.data).map(
                    (task, index) => (
                      <TableRow key={index} className={classes.tableRow}>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center", textDecoration: "underline" }}
                        >
                          <Link
                            to={`/project-logs/${task?.leadId}`}
                            target="_blank"
                          >
                            {task.leadId?.lead_no || task.lead_no || "N/A"}
                          </Link>
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.name || "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Sales_Executive || "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.ASM_Name || "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.taskCreatedBy || "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Expected_Closure_Date
                            ? moment(task?.Expected_Closure_Date).format(
                                "DD-MM-YYYY"
                              )
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Create_Date
                            ? moment(task?.Create_Date).format("DD-MM-YYYY")
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Current_Date
                            ? moment(task?.Current_Date).format("DD-MM-YYYY")
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Days_Overdue ||
                            (task?.Days_Overdue
                              ? moment().diff(
                                  moment(task?.Days_Overdue),
                                  "days"
                                )
                              : "N/A")}
                        </TableCell>
                        <TableCell
                          component="th"
                          onClick={() => handleTaskAssignTitle(task)}
                          style={{
                            textAlign: "center",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          {task?.Task_Title}
                        </TableCell>
                        <TableCell component="th">
                          {!(
                            task?.status === "Closed" ||
                            task?.status === "Resolved"
                          ) && (
                            <CenterFocusWeakIcon
                              className={classes.handOnHover}
                              style={{ color: "#3299d8" }}
                              onClick={() => {
                                resolveIssue(task);
                              }}
                              titleAccess="Resolve Issue"
                            />
                          )}
                        </TableCell>
                      </TableRow>
                    )
                  )}
                  {filterDataByDateRange(tablesData?.table7?.data).length ===
                    0 && (
                    <TableRow>
                      <TableCell colSpan={11} align="center">
                        {filterApplied
                          ? "No overdue tasks found for selected date range"
                          : "No overdue tasks found"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        {/* Table 6: Left Pipeline Tasks */}
        <Accordion
          expanded={expanded.table6}
          onChange={handleAccordionChange("table6")}
          className={`${classes.accordionMargin} ${getAccordionClass(
            "table6"
          )}`}
        >
          <Tooltip
            title={
              isTableDisabled("table6")
                ? "This section is disabled because other tasks are pending."
                : ""
            }
            arrow
            placement="top"
            classes={{
              tooltip: classes.customTooltip,
              arrow: classes.customArrow,
            }}
          >
            <div>
              <AccordionSummary
                disabled={isTableDisabled("table6")}
                expandIcon={
                  isTableDisabled("table6") ? (
                    <LockIcon />
                  ) : (
                    getExpandIcon("table6")
                  )
                }
                aria-controls="panel6a-content"
                id="panel6a-header"
              >
                <div className={classes.accordionHeading}>
                  <Typography className={classes.accordionHeadingText}>
                    Leads where task is not assigned-Left Pipeline
                    {getTableStatus("table6")}
                  </Typography>
                  <span className={classes.countBadge}>
                    {filterApplied
                      ? filterDataByDateRange(tablesData?.table6?.data).length
                      : tablesData?.table6?.data?.length}
                  </span>
                </div>
              </AccordionSummary>
            </div>
          </Tooltip>
          <AccordionDetails style={{ flexDirection: "column", padding: 0 }}>
            {renderTeamDetails(tablesData?.table6?.teamDetails)}
            {renderFilters(tablesData?.table6?.filtersApplied)}
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Sno.</StyledTableCell>
                    <StyledTableCell>Lead no.</StyledTableCell>
                    <StyledTableCell>Customer name</StyledTableCell>
                    <StyledTableCell>Sales Executive</StyledTableCell>
                    <StyledTableCell>ASM</StyledTableCell>
                    <StyledTableCell>Lead created date</StyledTableCell>
                    <StyledTableCell>Current stage</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filterDataByDateRange(tablesData?.table6?.data).map(
                    (lead, index) => (
                      <TableRow key={index} className={classes.tableRow}>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center", textDecoration: "underline" }}
                        >
                          <Link
                            to={`/project-logs/${lead._id}`}
                            target="_blank"
                          >
                            {lead?.lead_no || "NA"}
                          </Link>
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.customerId?.name || "NA"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.assignTo?.name || "NA"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.salesAssistantManager?.name || "NA"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {lead?.createdAt
                            ? moment(lead?.createdAt).format("DD-MM-YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell
                          scomponent="th"
                          tyle={{ textAlign: "center" }}
                        >
                          {lead?.currentStage || "NA"}
                        </TableCell>
                      </TableRow>
                    )
                  )}
                  {filterDataByDateRange(tablesData?.table6?.data).length ===
                    0 && (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        {filterApplied
                          ? "No leads found for selected date range"
                          : "No leads found"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        {/* Table 8: Task assigned to team (due yesterday) */}
        <Accordion
          expanded={expanded.table8}
          onChange={handleAccordionChange("table8")}
          className={`${classes.accordionMargin} ${getAccordionClass(
            "table8"
          )}`}
        >
          <Tooltip
            title={
              isTableDisabled("table8")
                ? "This section is disabled because other tasks are pending."
                : ""
            }
            arrow
            placement="top"
            classes={{
              tooltip: classes.customTooltip,
              arrow: classes.customArrow,
            }}
          >
            <div>
              <AccordionSummary
                disabled={isTableDisabled("table8")}
                expandIcon={
                  isTableDisabled("table8") ? (
                    <LockIcon />
                  ) : (
                    getExpandIcon("table8")
                  )
                }
                aria-controls="panel8a-content"
                id="panel8a-header"
              >
                <div className={classes.accordionHeading}>
                  <Typography className={classes.accordionHeadingText}>
                    Task assigned and reminder to team
                    {getTableStatus("table8")}
                  </Typography>
                  <span className={classes.countBadge}>
                    {filterApplied
                      ? filterDataByDateRange(tablesData?.table8?.data).length
                      : tablesData?.table8?.data?.length}
                  </span>
                </div>
              </AccordionSummary>
            </div>
          </Tooltip>
          <AccordionDetails style={{ flexDirection: "column", padding: 0 }}>
            {renderTeamDetails(tablesData?.table8?.teamDetails)}
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Sl No.</StyledTableCell>
                    <StyledTableCell>Lead no.</StyledTableCell>
                    <StyledTableCell>Customer Name</StyledTableCell>
                    <StyledTableCell>Sales Executive</StyledTableCell>
                    <StyledTableCell>ASM</StyledTableCell>
                    <StyledTableCell>Assigned BY</StyledTableCell>
                    <StyledTableCell>Task Due Date</StyledTableCell>
                    <StyledTableCell>Create Date</StyledTableCell>
                    <StyledTableCell>Current Date</StyledTableCell>
                    <StyledTableCell>Days Overdue</StyledTableCell>
                    <StyledTableCell colSpan={2}>
                      {" "}
                      Task Details{" "}
                    </StyledTableCell>
                    <StyledTableCell>Reminder Details </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filterDataByDateRange(tablesData?.table8?.data).map(
                    (task, index) => (
                      <TableRow key={index} className={classes.tableRow}>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center", textDecoration: "underline" }}
                        >
                          <Link
                            to={`/project-logs/${task.leadId}`}
                            target="_blank"
                          >
                            {task.leadId?.lead_no || task.lead_no || "N/A"}
                          </Link>
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.name || "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Sales_Executive || "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.ASM_Name || "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.taskCreatedBy || "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Expected_Closure_Date
                            ? moment(task?.Expected_Closure_Date).format(
                                "DD-MM-YYYY"
                              )
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Create_Date
                            ? moment(task?.Create_Date).format("DD-MM-YYYY")
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Current_Date
                            ? moment(task?.Current_Date).format("DD-MM-YYYY")
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Days_Overdue ||
                            (task?.Days_Overdue
                              ? moment().diff(
                                  moment(task?.Days_Overdue),
                                  "days"
                                )
                              : "N/A")}
                        </TableCell>
                        <TableCell
                          component="th"
                          onClick={
                            task?.Task_Title
                              ? () => handleTaskAssignTitle(task)
                              : undefined
                          }
                          style={{
                            textAlign: "center",
                            cursor: task?.Task_Title ? "pointer" : "default",
                            textDecoration: task?.Task_Title
                              ? "underline"
                              : "none",
                          }}
                        >
                          {task?.Task_Title ?? "-"}
                        </TableCell>

                        <TableCell component="th">
                          {task?.Task_Title &&
                            task.status !== "Closed" &&
                            task.status !== "Resolved" && (
                              <CenterFocusWeakIcon
                                className={classes.handOnHover}
                                style={{ color: "#3299d8" }}
                                onClick={() => resolveIssue(task)}
                                titleAccess="Resolve Issue"
                              />
                            )}
                        </TableCell>

                        <TableCell
                          component="th"
                          {...(task?.Notes && {
                            onClick: () => handleReminderDueTitle(task),
                            style: {
                              padding: 10,
                              textAlign: "center",
                              textDecoration: "underline",
                              cursor: "pointer",
                            },
                          })}
                          // Fallback style when no Notes (optional)
                          style={{
                            padding: 10,
                            textAlign: "center",
                            textDecoration: task?.Notes ? "underline" : "none",
                            cursor: task?.Notes ? "pointer" : "default",
                          }}
                        >
                          {task?.Notes ?? "-"}
                        </TableCell>
                      </TableRow>
                    )
                  )}
                  {filterDataByDateRange(tablesData?.table8?.data).length ===
                    0 && (
                    <TableRow>
                      <TableCell colSpan={11} align="center">
                        {filterApplied
                          ? "No team overdue tasks found for selected date range"
                          : "No team overdue tasks found"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        {/* Table 9: ASM Upcoming Tasks (due today or later) */}
        <Accordion
          expanded={expanded.table9}
          onChange={handleAccordionChange("table9")}
          className={`${classes.accordionMargin} ${getAccordionClass(
            "table9"
          )}`}
        >
          <Tooltip
            title={
              isTableDisabled("table9")
                ? "This section is disabled because other tasks are pending."
                : ""
            }
            arrow
            placement="top"
            classes={{
              tooltip: classes.customTooltip,
              arrow: classes.customArrow,
            }}
          >
            <div>
              <AccordionSummary
                disabled={isTableDisabled("table9")}
                expandIcon={
                  isTableDisabled("table9") ? (
                    <LockIcon />
                  ) : (
                    getExpandIcon("table9")
                  )
                }
                aria-controls="panel9a-content"
                id="panel9a-header"
              >
                <div className={classes.accordionHeading}>
                  <Typography className={classes.accordionHeadingText}>
                    Task assigned to ASM
                    {getTableStatus("table9")}
                  </Typography>
                  <span className={classes.countBadge}>
                    {filterApplied
                      ? filterDataByDateRange(tablesData.table9.data).length
                      : tablesData.table9.data.length}
                  </span>
                </div>
              </AccordionSummary>
            </div>
          </Tooltip>
          <AccordionDetails style={{ flexDirection: "column", padding: 0 }}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Sl No.</StyledTableCell>
                    <StyledTableCell>Lead no.</StyledTableCell>
                    <StyledTableCell>Customer Name</StyledTableCell>
                    <StyledTableCell>Sales Executive</StyledTableCell>
                    <StyledTableCell>ASM</StyledTableCell>
                    <StyledTableCell>Assigned BY</StyledTableCell>
                    <StyledTableCell>Task Due Date</StyledTableCell>
                    <StyledTableCell>Create Date</StyledTableCell>
                    <StyledTableCell>Current Date</StyledTableCell>
                    <StyledTableCell>Due Days</StyledTableCell>
                    <StyledTableCell colSpan={2}> Task Details</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filterDataByDateRange(tablesData?.table9?.data).map(
                    (task, index) => (
                      <TableRow key={index} className={classes.tableRow}>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center", textDecoration: "underline" }}
                        >
                          <Link
                            to={`/project-logs/${task?.leadId}`}
                            target="_blank"
                          >
                            {task.leadId?.lead_no || task?.lead_no || "N/A"}
                          </Link>
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Customer || "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Sales_Executive || "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.ASM_Name || "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.taskCreatedBy || "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Expected_Closure_Date
                            ? moment(task?.Expected_Closure_Date).format(
                                "DD-MM-YYYY"
                              )
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Create_Date
                            ? moment(task?.Create_Date).format("DD-MM-YYYY")
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Current_Date
                            ? moment(task?.Current_Date).format("DD-MM-YYYY")
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Days_to_Deadline ||
                            (task?.Days_to_Deadline
                              ? moment().diff(
                                  moment(task?.Days_to_Deadline),
                                  "days"
                                )
                              : "N/A")}
                        </TableCell>
                        <TableCell
                          component="th"
                          onClick={() => handleTaskAssignTitle(task)}
                          style={{
                            textAlign: "center",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          {task?.Task_Title}
                        </TableCell>
                        <TableCell component="th">
                          {!(
                            task?.status === "Closed" ||
                            task?.status === "Resolved"
                          ) && (
                            <CenterFocusWeakIcon
                              className={classes.handOnHover}
                              style={{ color: "#3299d8" }}
                              onClick={() => {
                                resolveIssue(task);
                              }}
                              titleAccess="Resolve Issue"
                            />
                          )}
                        </TableCell>
                      </TableRow>
                    )
                  )}
                  {filterDataByDateRange(tablesData?.table9?.data).length ===
                    0 && (
                    <TableRow>
                      <TableCell colSpan={11} align="center">
                        {filterApplied
                          ? "No overdue tasks found for selected date range"
                          : "No overdue tasks found"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        {/* Table 10: Team Upcoming Tasks (due today or later) */}
        <Accordion
          expanded={expanded.table10}
          onChange={handleAccordionChange("table10")}
          className={`${classes.accordionMargin} ${getAccordionClass(
            "table10"
          )}`}
        >
          <Tooltip
            title={
              isTableDisabled("table10")
                ? "This section is disabled because other tasks are pending."
                : ""
            }
            arrow
            placement="top"
            classes={{
              tooltip: classes.customTooltip,
              arrow: classes.customArrow,
            }}
          >
            <div>
              <AccordionSummary
                disabled={isTableDisabled("table10")}
                expandIcon={
                  isTableDisabled("table10") ? (
                    <LockIcon />
                  ) : (
                    getExpandIcon("table10")
                  )
                }
                aria-controls="panel10a-content"
                id="panel10a-header"
              >
                <div className={classes.accordionHeading}>
                  <Typography className={classes.accordionHeadingText}>
                    Task and reminder assigned to team
                    {getTableStatus("table10")}
                  </Typography>
                  <span className={classes.countBadge}>
                    {filterApplied
                      ? filterDataByDateRange(tablesData?.table10?.data).length
                      : tablesData?.table10?.data?.length}
                  </span>
                </div>
              </AccordionSummary>
            </div>
          </Tooltip>
          <AccordionDetails style={{ flexDirection: "column", padding: 0 }}>
            {renderTeamDetails(tablesData?.table10?.teamDetails)}
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Sl No.</StyledTableCell>
                    <StyledTableCell>Lead no.</StyledTableCell>
                    <StyledTableCell>Customer Name</StyledTableCell>
                    <StyledTableCell>Sales Executive</StyledTableCell>
                    <StyledTableCell>ASM</StyledTableCell>
                    <StyledTableCell>Assigned BY</StyledTableCell>
                    <StyledTableCell>Task Due Date</StyledTableCell>
                    <StyledTableCell>Create Date</StyledTableCell>
                    <StyledTableCell>Current Date</StyledTableCell>
                    <StyledTableCell>Due Days</StyledTableCell>
                    <StyledTableCell colSpan={2}>
                      {" "}
                      Task Details{" "}
                    </StyledTableCell>
                    <StyledTableCell>Reminder Details </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filterDataByDateRange(tablesData?.table10?.data).map(
                    (task, index) => (
                      <TableRow key={index} className={classes.tableRow}>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center", textDecoration: "underline" }}
                        >
                          <Link
                            to={`/project-logs/${task?.leadId}`}
                            target="_blank"
                          >
                            {task.leadId?.lead_no || task.lead_no || "N/A"}
                          </Link>
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.name || "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Sales_Executive || "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.ASM_Name || "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.taskCreatedBy || "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Expected_Closure_Date
                            ? moment(task?.Expected_Closure_Date).format(
                                "DD-MM-YYYY"
                              )
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Create_Date
                            ? moment(task?.Create_Date).format("DD-MM-YYYY")
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Current_Date
                            ? moment(task?.Current_Date).format("DD-MM-YYYY")
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          component="th"
                          style={{ textAlign: "center" }}
                        >
                          {task?.Days_to_Deadline ||
                            (task?.Days_to_Deadline
                              ? moment().diff(
                                  moment(task?.Days_to_Deadline),
                                  "days"
                                )
                              : "N/A")}
                        </TableCell>
                        <TableCell
                          component="th"
                          onClick={
                            task?.Task_Title
                              ? () => handleTaskAssignTitle(task)
                              : undefined
                          }
                          style={{
                            textAlign: "center",
                            cursor: task?.Task_Title ? "pointer" : "default",
                            textDecoration: task?.Task_Title
                              ? "underline"
                              : "none",
                          }}
                        >
                          {task?.Task_Title ?? "-"}
                        </TableCell>

                        <TableCell component="th">
                          {task?.Task_Title &&
                            task.status !== "Closed" &&
                            task.status !== "Resolved" && (
                              <CenterFocusWeakIcon
                                className={classes.handOnHover}
                                style={{ color: "#3299d8" }}
                                onClick={() => resolveIssue(task)}
                                titleAccess="Resolve Issue"
                              />
                            )}
                        </TableCell>

                        <TableCell
                          component="th"
                          {...(task?.Notes && {
                            onClick: () => handleReminderDueTitle(task),
                            style: {
                              padding: 10,
                              textAlign: "center",
                              textDecoration: "underline",
                              cursor: "pointer",
                            },
                          })}
                          // Fallback style when no Notes (optional)
                          style={{
                            padding: 10,
                            textAlign: "center",
                            textDecoration: task?.Notes ? "underline" : "none",
                            cursor: task?.Notes ? "pointer" : "default",
                          }}
                        >
                          {task?.Notes ?? "-"}
                        </TableCell>
                      </TableRow>
                    )
                  )}
                  {filterDataByDateRange(tablesData?.table10?.data).length ===
                    0 && (
                    <TableRow>
                      <TableCell colSpan={11} align="center">
                        {filterApplied
                          ? "No team overdue tasks found for selected date range"
                          : "No team overdue tasks found"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      </div>
    </Paper>
    </>
  );
};

export default ASMDashboard;